import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { CartService } from '../../services/cart.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent, TranslateModule],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss'
})
export class PaymentSuccessComponent implements OnInit {
  reservationLocator: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService
  ) {}

  ngOnInit(): void {
    this.reservationLocator = this.route.snapshot.paramMap.get('locator');
    this.cartService.clearCart();
  }

  goToReservationDetails(): void {
    if (this.reservationLocator) {
      this.router.navigate(['/reservation', this.reservationLocator]);
    }
  }
}
